import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import _ from 'lodash';
import Icon from '../../../core/Icon';

import { Bell } from '../../../../../assets/images';

import { StyledWidgetNotifications } from './style';
import { newGetNotificationNoViewed } from '../../../../utils/apiHeader';
import NotificationList from '../../../core/NotificationList/NotificationList';

const WidgetNotifications = ({ notifications, className }) => {
  const [list, setList] = useState(null);
  const getNotifications = () => {
    if (notifications && notifications.length > 0) {
      newGetNotificationNoViewed({}).then(notificationList => {
        setList(notificationList);
      });
    }
  };

  const { ipcRenderer } = window.require('electron');

  const deleteNotification = idNotification => {
    getNotifications();
    const auxList = list;
    const removedItem = _.remove(
      auxList.content,
      item => item?.idNotification === idNotification
    );
    if (removedItem !== undefined) {
      auxList.size -= 1;
      auxList.total -= 1;
      setList(auxList);
    }
  };

  useEffect(() => {
    getNotifications();
  }, [notifications]);

  const renderNotifications = () => {
    let result = null;
    const { length } = list.content.filter(not => not.viewed === false);
    ipcRenderer.sendSync('update-badge', length);
    if (length > 0) {
      result = (
        <NotificationList
          isWidget
          notificationList={list.content}
          onDelete={idNotification => deleteNotification(idNotification)}
        />
      );
    } else if (length === 0) {
      result = (
        <p className="txtNoNotifications">No tienes ninguna notificación.</p>
      );
    }
    return result;
  };

  return (
    <StyledWidgetNotifications className={className}>
      <h2 className="title">
        <Icon svg={Bell} className="icon-title" />
        Notificaciones
      </h2>
      {list && renderNotifications()}
    </StyledWidgetNotifications>
  );
};

const mapStateToProps = state => ({
  notifications: state.notifications.notificationsList
});

export default connect(mapStateToProps)(WidgetNotifications);
